module.exports = __webpack_public_path__ + "static/img/icon43.0dc843b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon43.png
// module id = iRz4
// module chunks = 0